<template>
  <div class="form-wrapper">
    <transition name="fade" mode="out-in">
      <ValidationObserver ref="formGeneral" v-if="!success" key="1">
        <form @submit.prevent="Submit" @keyup.enter="Submit">
          <ValidationProvider
            name="Name"
            rules="required"
            v-slot="{ classes, errors, valid }"
          >
            <InputSimpleTextVertical
              label="Name"
              left_icon="fa-user"
              :classes="classes"
              :valid="valid"
              v-model="form.name"
              placeholder="Name"
            />
            <p class="help">{{ errors[0] }}</p>
          </ValidationProvider>

          <ValidationProvider
            name="Subject"
            rules="required"
            v-slot="{ classes, errors, valid }"
          >
            <InputSimpleTextVertical
              label="Subject"
              left_icon="fa-user"
              :classes="classes"
              :valid="valid"
              v-model="form.subject"
              placeholder="Subject"
            />
            <p class="help">{{ errors[0] }}</p>
          </ValidationProvider>

          <ValidationProvider
            name="Email"
            rules="required|email"
            v-slot="{ classes, errors, valid }"
          >
            <InputSimpleTextVertical
              label="Email"
              left_icon="fa-envelope"
              :classes="classes"
              :valid="valid"
              v-model="form.email"
              placeholder="Email"
            />
            <p class="help">{{ errors[0] }}</p>
          </ValidationProvider>

          <ValidationProvider
            name="Phone number"
            :rules="{ required: true, regex: /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/ }"
            v-slot="{ classes, errors, valid }"
          >
            <InputSimpleTextVertical
              label="Phone number"
              left_icon="fa-phone"
              
              :classes="classes"
              :valid="valid"
              v-model="form.phone_number"
              placeholder="Phone Number"
            />
            <p class="help">{{ errors[0] }}</p>
          </ValidationProvider>

          <ValidationProvider
            name="Message"
            rules="required"
            v-slot="{ classes, errors, valid }"
          >
            <InputTextArea
              label="Message"
              :classes="classes"
              :valid="valid"
              v-model="form.message"
            />
            <p class="help">{{ errors[0] }}</p>
          </ValidationProvider>
          <button
            v-if="sentmessage == false && failedmessage == false"
            type="submit"
            :class="['button', 'is-medium', { 'is-loading': loadingmessage }]"
          >
            Submit
          </button>
          <button
            v-else-if="sentmessage == false && failedmessage == true"
            type="submit"
            :class="['button', 'is-medium', { 'is-danger': failedmessage }]"
          >
            Error
          </button>
          <button
            v-else-if="sentmessage == true && failedmessage == false"
            type="submit"
            disabled
            :class="['button', 'is-medium', { 'is-success': sentmessage }]"
          >
            Sent
          </button>
        </form>
      </ValidationObserver>
      <div v-else key="2" class="successfulContact">
        <h2
          class="title is-6 has-text-centered"
        >
          Message Submitted
        </h2>
        <h2
          class="subtitle is-6 has-text-centered"
        >
          You will be contacted soon!
        </h2>
        <sweetalert-icon icon="success" color="#00c5fd"></sweetalert-icon>
      </div>
    </transition>
  </div>
</template>

<script>
import SweetalertIcon from "vue-sweetalert-icons";
import InputSimpleTextVertical from '@/components/atoms/InputSimpleTextVertical.vue';
import InputTextArea from '@/components/atoms/InputTextArea.vue';
export default {
  components: {
    InputSimpleTextVertical,
    InputTextArea,
    SweetalertIcon
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        subject: '',
        phone_number: '',
        message: '',
      },
      sentmessage: false,
      failedmessage: false,
      loadingmessage: false,
      success : false,
    };
  },
  methods: {
    async Submit() {
      this.loading = true
      this.sentmessage = false;
      this.failedmessage = false;
      try {
        const isValid = await this.$refs.formGeneral.validate();
        if (isValid) {
          const response = await this.$http.post('/api/contact', {
            name: this.form.name,
            email: this.form.email,
            phone_number: this.form.phone_number,
            subject: this.form.subject,
            message: this.form.message,
          });
          if (response.status == 200) {
            this.success = true;
            this.reset();
            // this.loadingmessage = true;
            setTimeout(() => {
            //   this.sentmessage = true;
            //   this.failedmessage = false;
              this.success = false;
            }, 2000);
          }
        }
      } catch (error) {
        console.log(error);
        this.loadingmessage = true;
        setTimeout(() => {
          this.loading = false;
          this.failedmessage = true;
          this.sentmessage = false;
        }, 2000);
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.form = {
        name: '',
        email: '',
        phone_number: Number,
        message: '',
      };
      // this.$refs.formGeneral.reset();
    },
  },
};
</script>

<style scoped>
.button {
  background: #333333;
  color: white;
  border-radius: 0.75rem;
  width: 95%;
}

h2,
hr {
  margin: 2rem;
}

p {
  margin: 0 2rem;
  color: #ff0000;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.successfulContact {
  height: 46.5vh;
}
</style>
